export { default } from './not-found-page';
